import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import LocationsMenu from '../components/locations/LocationsMenu.vue';
import LocationsList from '../components/locations/LocationsList.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationsView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LocationsMenu),
    (_unref(route).path === '/locations')
      ? (_openBlock(), _createBlock(LocationsList, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})